import React from 'react';

export default function IconPlus(props) {
	return (
		<svg width="9" height="9" viewBox="0 0 9 9" {...props}>
			<rect y="4" width="9" height="1" fill="currentColor" />
			<rect x="4" width="1" height="9" fill="currentColor" />
		</svg>
	);
}
